import { render, staticRenderFns } from "./Investigations.vue?vue&type=template&id=74675c93&"
import script from "./Investigations.vue?vue&type=script&lang=ts&"
export * from "./Investigations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74675c93')) {
      api.createRecord('74675c93', component.options)
    } else {
      api.reload('74675c93', component.options)
    }
    module.hot.accept("./Investigations.vue?vue&type=template&id=74675c93&", function () {
      api.rerender('74675c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/Investigations.vue"
export default component.exports